import React from "react";
import { Wrench, ShoppingCart, Settings, ArrowUpRight, Zap, Gauge, FlaskConical } from "lucide-react";

const services = [
  {
    icon: ShoppingCart,
    code: "01",
    title: "Venta de Transformadores",
    desc: "Diseño y suministro de transformadores tipo aceite para uso industrial, comercial y de distribución eléctrica con garantía extendida.",
    points: ["Desde 5 kVA hasta 3MVA", "Tipo aceite", "RETIE / NTC 818", "Entrega ágil en Santander"],
    img: "/img/operacion/servicio-venta.jpg",
  },
  {
    icon: Wrench,
    code: "02",
    title: "Reparación Especializada",
    desc: "Diagnóstico avanzado, cambio de bobinas, núcleo, aislación y calibración profesional para devolver la operación a su transformador.",
    points: ["Rebobinado", "Cambio de núcleo", "Tratamiento de aceite", "Pruebas dieléctricas"],
    img: "/img/operacion/servicio-reparacion.jpg",
  },
  {
    icon: Settings,
    code: "03",
    title: "Mantenimiento Pred / Prev",
    desc: "Limpieza, ajuste, pruebas eléctricas y recuperación de equipos para prolongar la vida útil de su parque de transformación.",
    points: ["Termografía", "Análisis físico-químico", "Megger / TTR / Hipot", "Reporte técnico"],
    img: "/img/operacion/servicio-mantenimiento.jpg",
  },
];

const capabilities = [
  { icon: Zap, label: "Emergencia 24/7", value: "Respuesta < 4h" },
  { icon: Gauge, label: "Pruebas in-situ", value: "Equipos calibrados" },
  { icon: FlaskConical, label: "Laboratorio propio", value: "Aceite + dieléctrico" },
];

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative py-24 lg:py-32 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#ff6b00]" />
              <span>Servicios · 03</span>
            </div>
            <h2
              data-testid="services-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter max-w-3xl"
            >
              Soluciones integrales en{" "}
              <span className="text-[#ff6b00]">transformadores</span> eléctricos.
            </h2>
          </div>
          <p className="text-[#a0aabf] max-w-md text-base leading-relaxed">
            Trabajamos con sector industrial, comercial y distribución eléctrica
            ofreciendo respuestas técnicas medibles y trazables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {services.map((s) => (
            <article
              key={s.code}
              data-testid={`service-card-${s.code}`}
              className="group relative bg-[#0a0a0a] hover:bg-[#12141a] p-8 lg:p-10 transition-all duration-500"
            >
              <div className="aspect-[4/3] mb-6 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
              </div>

              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 grid place-items-center bg-[#ff6b00] text-black">
                    <s.icon className="w-5 h-5" strokeWidth={2.5} />
                  </span>
                  <span className="font-mono text-xs text-[#a0aabf]">
                    /{s.code}
                  </span>
                </div>
                <ArrowUpRight className="w-5 h-5 text-[#a0aabf] group-hover:text-[#ff6b00] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </div>

              <h3 className="font-display text-2xl font-bold mb-3 tracking-tight">
                {s.title}
              </h3>
              <p className="text-[#a0aabf] text-sm leading-relaxed mb-6">
                {s.desc}
              </p>

              <ul className="space-y-2 pt-6 border-t border-white/5">
                {s.points.map((p) => (
                  <li
                    key={p}
                    className="flex items-center gap-3 text-xs text-[#a0aabf]"
                  >
                    <span className="w-1 h-1 bg-[#ff6b00]" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Capabilities row */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {capabilities.map((c) => (
            <div
              key={c.label}
              className="flex items-center gap-4 p-5 border border-white/5 bg-[#12141a]"
            >
              <c.icon className="w-7 h-7 text-[#ff6b00]" strokeWidth={1.5} />
              <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#a0aabf]">
                  {c.label}
                </div>
                <div className="font-display text-base font-semibold">
                  {c.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
